import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DownloadSimple, X, AppleLogo, AndroidLogo, DeviceMobile } from "@phosphor-icons/react";

const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOSHelp, setShowIOSHelp] = useState(false);

  useEffect(() => {
    const ua = window.navigator.userAgent;
    const ios = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || localStorage.getItem("xookmedia_install_dismissed") === "1") return;
    setIsIOS(ios);

    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    // iOS doesn't fire the event — show our helper instead after delay
    if (ios) {
      const t = setTimeout(() => setVisible(true), 4000);
      return () => { window.removeEventListener("beforeinstallprompt", handler); clearTimeout(t); };
    }
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (isIOS) { setShowIOSHelp(true); return; }
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome === "accepted") {
      setVisible(false);
      localStorage.setItem("xookmedia_install_dismissed", "1");
    }
    setDeferred(null);
  };

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem("xookmedia_install_dismissed", "1");
  };

  if (!visible) return null;

  return (
    <div data-testid="install-banner" className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:bottom-6 sm:max-w-sm z-50 rounded-2xl border border-[#E11D48]/40 bg-[#0f0f10]/95 backdrop-blur-xl shadow-2xl shadow-[#E11D48]/20 p-4">
      <button onClick={dismiss} data-testid="install-dismiss" className="absolute top-2 right-2 text-zinc-500 hover:text-white"><X size={16} /></button>
      <div className="flex items-start gap-3">
        <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#E11D48] to-[#7A0E2A] flex items-center justify-center shrink-0">
          <DeviceMobile size={22} weight="fill" />
        </div>
        <div className="flex-1">
          <div className="font-display font-bold text-sm">Installer XooKmédia</div>
          <p className="text-xs text-zinc-400 mt-0.5 mb-3">Accès rapide depuis votre écran d'accueil. Notifications & live en un clic.</p>
          {!showIOSHelp ? (
            <Button data-testid="install-confirm" size="sm" onClick={install} className="bg-[#E11D48] hover:bg-[#BE123C] w-full">
              <DownloadSimple weight="bold" className="mr-1" /> Installer l'app
            </Button>
          ) : (
            <div className="text-xs text-zinc-300 space-y-1 leading-relaxed">
              <p className="flex items-center gap-1"><AppleLogo weight="fill" /> Sur iPhone :</p>
              <p>1. Touchez l'icône <span className="font-bold">Partage</span></p>
              <p>2. Choisissez <span className="font-bold">"Sur l'écran d'accueil"</span></p>
              <p>3. Validez !</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InstallPrompt;
